import React, { useContext } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { SearchContext } from "components/store/source";
import { resetAllFilters } from "components/store/source/actions/searchCriteriaActions";
import { Button, Header, Text } from "components/ui/source";

import styles from "./EmptyResults.module.scss";

function EmptyResults({ className }) {
  const { dispatch } = useContext(SearchContext);

  const resetFilter = () => {
    dispatch(resetAllFilters());
  };

  return (
    <div className={classnames(className, styles.container)}>
      <Header
        className={styles.title}
        size="sm-md"
        type="headline4"
        translateKey="listing:availability.emptyResults.title"
      />

      <Text
        className={styles.description}
        types={["body1"]}
        translateKey="listing:availability.emptyResults.description"
      />

      <Button
        className={styles.resetFilterButton}
        textProps={{
          types: ["body1"],
          translateKey: "listing:availability.emptyResults.cta",
        }}
        upperCase={false}
        onClick={resetFilter}
      />
    </div>
  );
}

EmptyResults.propTypes = {
  className: PropTypes.string,
};

export default EmptyResults;
